/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateQuizPlanOrderRequest,
  GenerateOrderIdParams,
  GetPaymentStatusParams,
  GetQuizPlanOrderParams,
  HandlePaymentSuccessParams,
  PriceCalculationRequest,
  RecordPaymentPendingRequest,
  SuccessBodyGetUserPlanAvailabilityResponse,
  SuccessBodyPaymentStatusResponse,
  SuccessBodyPriceCalculationResponse,
  SuccessBodyQuizPlanOrderResponse,
  SuccessBodyQuizPlanPaymentResponse,
  SuccessBodyString,
  SuccessBodyUnit,
  TossWebhookEvent
} from '.././_model';

import { httpsInstance } from '../../httpClient';
import type { ErrorType , BodyType } from '../../httpClient';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * PAYMENT_STATUS_CHANGED, CANCEL_STATUS_CHANGED 이벤트를 처리합니다. 결제 상태 웹훅은 서버 주문의 Antom route/amount/currency 와 대조한 뒤 반영합니다.
 * @summary Toss webhook 수신
 */
export const handleTossWebhook = (
    tossWebhookEvent: BodyType<TossWebhookEvent>,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyUnit>(
      {url: `/webhooks/tosspayments/quiz-plan-payments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tossWebhookEvent, signal
    },
      options);
    }
  


export const getHandleTossWebhookMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handleTossWebhook>>, TError,{data: BodyType<TossWebhookEvent>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof handleTossWebhook>>, TError,{data: BodyType<TossWebhookEvent>}, TContext> => {

const mutationKey = ['handleTossWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handleTossWebhook>>, {data: BodyType<TossWebhookEvent>}> = (props) => {
          const {data} = props ?? {};

          return  handleTossWebhook(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HandleTossWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof handleTossWebhook>>>
    export type HandleTossWebhookMutationBody = BodyType<TossWebhookEvent>
    export type HandleTossWebhookMutationError = ErrorType<unknown>

    /**
 * @summary Toss webhook 수신
 */
export const useHandleTossWebhook = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handleTossWebhook>>, TError,{data: BodyType<TossWebhookEvent>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof handleTossWebhook>>,
        TError,
        {data: BodyType<TossWebhookEvent>},
        TContext
      > => {

      const mutationOptions = getHandleTossWebhookMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * 클라이언트 processing 페이지가 Toss pendingUrl 리다이렉트 파라미터를 서버에 전달합니다. 결제 확정 전이므로 payment row 는 만들지 않고 attempt 상태만 PENDING 으로 기록합니다.
 * @summary Antom 비동기 결제 pending 기록
 */
export const recordPaymentPending = (
    recordPaymentPendingRequest: BodyType<RecordPaymentPendingRequest>,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyPaymentStatusResponse>(
      {url: `/quiz-plans/payment/pending`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recordPaymentPendingRequest, signal
    },
      options);
    }
  


export const getRecordPaymentPendingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordPaymentPending>>, TError,{data: BodyType<RecordPaymentPendingRequest>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof recordPaymentPending>>, TError,{data: BodyType<RecordPaymentPendingRequest>}, TContext> => {

const mutationKey = ['recordPaymentPending'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordPaymentPending>>, {data: BodyType<RecordPaymentPendingRequest>}> = (props) => {
          const {data} = props ?? {};

          return  recordPaymentPending(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordPaymentPendingMutationResult = NonNullable<Awaited<ReturnType<typeof recordPaymentPending>>>
    export type RecordPaymentPendingMutationBody = BodyType<RecordPaymentPendingRequest>
    export type RecordPaymentPendingMutationError = ErrorType<unknown>

    /**
 * @summary Antom 비동기 결제 pending 기록
 */
export const useRecordPaymentPending = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordPaymentPending>>, TError,{data: BodyType<RecordPaymentPendingRequest>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordPaymentPending>>,
        TError,
        {data: BodyType<RecordPaymentPendingRequest>},
        TContext
      > => {

      const mutationOptions = getRecordPaymentPendingMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const generateOrderId = (
    params: GenerateOrderIdParams,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyString>(
      {url: `/quiz-plans/payment/generate-order-id`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getGenerateOrderIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateOrderId>>, TError,{params: GenerateOrderIdParams}, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateOrderId>>, TError,{params: GenerateOrderIdParams}, TContext> => {

const mutationKey = ['generateOrderId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateOrderId>>, {params: GenerateOrderIdParams}> = (props) => {
          const {params} = props ?? {};

          return  generateOrderId(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateOrderIdMutationResult = NonNullable<Awaited<ReturnType<typeof generateOrderId>>>
    
    export type GenerateOrderIdMutationError = ErrorType<unknown>

    export const useGenerateOrderId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateOrderId>>, TError,{params: GenerateOrderIdParams}, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateOrderId>>,
        TError,
        {params: GenerateOrderIdParams},
        TContext
      > => {

      const mutationOptions = getGenerateOrderIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * 선택한 플랜에 대한 가격 견적을 계산합니다.
 * @summary 플랜 가격 견적 계산
 */
export const calculateEstimate = (
    priceCalculationRequest: BodyType<PriceCalculationRequest>,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyPriceCalculationResponse>(
      {url: `/quiz-plans/payment/estimate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: priceCalculationRequest, signal
    },
      options);
    }
  


export const getCalculateEstimateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calculateEstimate>>, TError,{data: BodyType<PriceCalculationRequest>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof calculateEstimate>>, TError,{data: BodyType<PriceCalculationRequest>}, TContext> => {

const mutationKey = ['calculateEstimate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calculateEstimate>>, {data: BodyType<PriceCalculationRequest>}> = (props) => {
          const {data} = props ?? {};

          return  calculateEstimate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CalculateEstimateMutationResult = NonNullable<Awaited<ReturnType<typeof calculateEstimate>>>
    export type CalculateEstimateMutationBody = BodyType<PriceCalculationRequest>
    export type CalculateEstimateMutationError = ErrorType<unknown>

    /**
 * @summary 플랜 가격 견적 계산
 */
export const useCalculateEstimate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calculateEstimate>>, TError,{data: BodyType<PriceCalculationRequest>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof calculateEstimate>>,
        TError,
        {data: BodyType<PriceCalculationRequest>},
        TContext
      > => {

      const mutationOptions = getCalculateEstimateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * 퀴즈 플랜 결제를 위한 주문을 생성합니다.
 * @summary 퀴즈 플랜 주문 생성
 */
export const createQuizPlanOrder = (
    createQuizPlanOrderRequest: BodyType<CreateQuizPlanOrderRequest>,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyQuizPlanOrderResponse>(
      {url: `/quiz-plans/payment/create-order`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createQuizPlanOrderRequest, signal
    },
      options);
    }
  


export const getCreateQuizPlanOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuizPlanOrder>>, TError,{data: BodyType<CreateQuizPlanOrderRequest>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createQuizPlanOrder>>, TError,{data: BodyType<CreateQuizPlanOrderRequest>}, TContext> => {

const mutationKey = ['createQuizPlanOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createQuizPlanOrder>>, {data: BodyType<CreateQuizPlanOrderRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createQuizPlanOrder(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateQuizPlanOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createQuizPlanOrder>>>
    export type CreateQuizPlanOrderMutationBody = BodyType<CreateQuizPlanOrderRequest>
    export type CreateQuizPlanOrderMutationError = ErrorType<unknown>

    /**
 * @summary 퀴즈 플랜 주문 생성
 */
export const useCreateQuizPlanOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuizPlanOrder>>, TError,{data: BodyType<CreateQuizPlanOrderRequest>}, TContext>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createQuizPlanOrder>>,
        TError,
        {data: BodyType<CreateQuizPlanOrderRequest>},
        TContext
      > => {

      const mutationOptions = getCreateQuizPlanOrderMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * 토스페이먼츠 결제 승인 콜백을 처리하고 워크스페이스를 생성합니다.
 * @summary 결제 승인 콜백 처리
 */
export const handlePaymentSuccess = (
    params: HandlePaymentSuccessParams,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyQuizPlanPaymentResponse>(
      {url: `/quiz-plans/payment/toss-callback/success`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getHandlePaymentSuccessQueryKey = (params: HandlePaymentSuccessParams,) => {
    return [`/quiz-plans/payment/toss-callback/success`, ...(params ? [params]: [])] as const;
    }

    
export const getHandlePaymentSuccessQueryOptions = <TData = Awaited<ReturnType<typeof handlePaymentSuccess>>, TError = ErrorType<unknown>>(params: HandlePaymentSuccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof handlePaymentSuccess>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHandlePaymentSuccessQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof handlePaymentSuccess>>> = ({ signal }) => handlePaymentSuccess(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof handlePaymentSuccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HandlePaymentSuccessQueryResult = NonNullable<Awaited<ReturnType<typeof handlePaymentSuccess>>>
export type HandlePaymentSuccessQueryError = ErrorType<unknown>


export function useHandlePaymentSuccess<TData = Awaited<ReturnType<typeof handlePaymentSuccess>>, TError = ErrorType<unknown>>(
 params: HandlePaymentSuccessParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof handlePaymentSuccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof handlePaymentSuccess>>,
          TError,
          Awaited<ReturnType<typeof handlePaymentSuccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHandlePaymentSuccess<TData = Awaited<ReturnType<typeof handlePaymentSuccess>>, TError = ErrorType<unknown>>(
 params: HandlePaymentSuccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof handlePaymentSuccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof handlePaymentSuccess>>,
          TError,
          Awaited<ReturnType<typeof handlePaymentSuccess>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHandlePaymentSuccess<TData = Awaited<ReturnType<typeof handlePaymentSuccess>>, TError = ErrorType<unknown>>(
 params: HandlePaymentSuccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof handlePaymentSuccess>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 결제 승인 콜백 처리
 */

export function useHandlePaymentSuccess<TData = Awaited<ReturnType<typeof handlePaymentSuccess>>, TError = ErrorType<unknown>>(
 params: HandlePaymentSuccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof handlePaymentSuccess>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHandlePaymentSuccessQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHandlePaymentSuccessSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof handlePaymentSuccess>>, TError = ErrorType<unknown>>(params: HandlePaymentSuccessParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof handlePaymentSuccess>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHandlePaymentSuccessQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof handlePaymentSuccess>>> = ({ signal }) => handlePaymentSuccess(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof handlePaymentSuccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HandlePaymentSuccessSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof handlePaymentSuccess>>>
export type HandlePaymentSuccessSuspenseQueryError = ErrorType<unknown>


export function useHandlePaymentSuccessSuspense<TData = Awaited<ReturnType<typeof handlePaymentSuccess>>, TError = ErrorType<unknown>>(
 params: HandlePaymentSuccessParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof handlePaymentSuccess>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHandlePaymentSuccessSuspense<TData = Awaited<ReturnType<typeof handlePaymentSuccess>>, TError = ErrorType<unknown>>(
 params: HandlePaymentSuccessParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof handlePaymentSuccess>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHandlePaymentSuccessSuspense<TData = Awaited<ReturnType<typeof handlePaymentSuccess>>, TError = ErrorType<unknown>>(
 params: HandlePaymentSuccessParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof handlePaymentSuccess>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 결제 승인 콜백 처리
 */

export function useHandlePaymentSuccessSuspense<TData = Awaited<ReturnType<typeof handlePaymentSuccess>>, TError = ErrorType<unknown>>(
 params: HandlePaymentSuccessParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof handlePaymentSuccess>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHandlePaymentSuccessSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 클라이언트가 결제 진행 상태를 주기적으로 조회합니다. READY/PENDING 은 spinner 유지, APPROVED 면 완료 페이지로, FAILED 면 에러 처리.
 * @summary 결제 상태 폴링 (Antom 비동기 결제용)
 */
export const getPaymentStatus = (
    params: GetPaymentStatusParams,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyPaymentStatusResponse>(
      {url: `/quiz-plans/payment/status`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetPaymentStatusQueryKey = (params: GetPaymentStatusParams,) => {
    return [`/quiz-plans/payment/status`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPaymentStatusQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentStatus>>, TError = ErrorType<unknown>>(params: GetPaymentStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentStatus>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentStatus>>> = ({ signal }) => getPaymentStatus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPaymentStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentStatus>>>
export type GetPaymentStatusQueryError = ErrorType<unknown>


export function useGetPaymentStatus<TData = Awaited<ReturnType<typeof getPaymentStatus>>, TError = ErrorType<unknown>>(
 params: GetPaymentStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentStatus>>,
          TError,
          Awaited<ReturnType<typeof getPaymentStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaymentStatus<TData = Awaited<ReturnType<typeof getPaymentStatus>>, TError = ErrorType<unknown>>(
 params: GetPaymentStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentStatus>>,
          TError,
          Awaited<ReturnType<typeof getPaymentStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaymentStatus<TData = Awaited<ReturnType<typeof getPaymentStatus>>, TError = ErrorType<unknown>>(
 params: GetPaymentStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentStatus>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 결제 상태 폴링 (Antom 비동기 결제용)
 */

export function useGetPaymentStatus<TData = Awaited<ReturnType<typeof getPaymentStatus>>, TError = ErrorType<unknown>>(
 params: GetPaymentStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentStatus>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPaymentStatusQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetPaymentStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentStatus>>, TError = ErrorType<unknown>>(params: GetPaymentStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentStatus>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentStatus>>> = ({ signal }) => getPaymentStatus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPaymentStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentStatus>>>
export type GetPaymentStatusSuspenseQueryError = ErrorType<unknown>


export function useGetPaymentStatusSuspense<TData = Awaited<ReturnType<typeof getPaymentStatus>>, TError = ErrorType<unknown>>(
 params: GetPaymentStatusParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentStatus>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaymentStatusSuspense<TData = Awaited<ReturnType<typeof getPaymentStatus>>, TError = ErrorType<unknown>>(
 params: GetPaymentStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentStatus>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaymentStatusSuspense<TData = Awaited<ReturnType<typeof getPaymentStatus>>, TError = ErrorType<unknown>>(
 params: GetPaymentStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentStatus>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 결제 상태 폴링 (Antom 비동기 결제용)
 */

export function useGetPaymentStatusSuspense<TData = Awaited<ReturnType<typeof getPaymentStatus>>, TError = ErrorType<unknown>>(
 params: GetPaymentStatusParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentStatus>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPaymentStatusSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 퀴즈 플랜 주문 정보를 조회합니다. READY 상태의 주문만 조회 가능합니다.
 * @summary 퀴즈 플랜 주문 조회
 */
export const getQuizPlanOrder = (
    params: GetQuizPlanOrderParams,
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyQuizPlanOrderResponse>(
      {url: `/quiz-plans/payment/order`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetQuizPlanOrderQueryKey = (params: GetQuizPlanOrderParams,) => {
    return [`/quiz-plans/payment/order`, ...(params ? [params]: [])] as const;
    }

    
export const getGetQuizPlanOrderQueryOptions = <TData = Awaited<ReturnType<typeof getQuizPlanOrder>>, TError = ErrorType<unknown>>(params: GetQuizPlanOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuizPlanOrder>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuizPlanOrderQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizPlanOrder>>> = ({ signal }) => getQuizPlanOrder(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuizPlanOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetQuizPlanOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getQuizPlanOrder>>>
export type GetQuizPlanOrderQueryError = ErrorType<unknown>


export function useGetQuizPlanOrder<TData = Awaited<ReturnType<typeof getQuizPlanOrder>>, TError = ErrorType<unknown>>(
 params: GetQuizPlanOrderParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuizPlanOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizPlanOrder>>,
          TError,
          Awaited<ReturnType<typeof getQuizPlanOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetQuizPlanOrder<TData = Awaited<ReturnType<typeof getQuizPlanOrder>>, TError = ErrorType<unknown>>(
 params: GetQuizPlanOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuizPlanOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizPlanOrder>>,
          TError,
          Awaited<ReturnType<typeof getQuizPlanOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetQuizPlanOrder<TData = Awaited<ReturnType<typeof getQuizPlanOrder>>, TError = ErrorType<unknown>>(
 params: GetQuizPlanOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuizPlanOrder>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 퀴즈 플랜 주문 조회
 */

export function useGetQuizPlanOrder<TData = Awaited<ReturnType<typeof getQuizPlanOrder>>, TError = ErrorType<unknown>>(
 params: GetQuizPlanOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuizPlanOrder>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetQuizPlanOrderQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetQuizPlanOrderSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getQuizPlanOrder>>, TError = ErrorType<unknown>>(params: GetQuizPlanOrderParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuizPlanOrder>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuizPlanOrderQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizPlanOrder>>> = ({ signal }) => getQuizPlanOrder(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuizPlanOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetQuizPlanOrderSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getQuizPlanOrder>>>
export type GetQuizPlanOrderSuspenseQueryError = ErrorType<unknown>


export function useGetQuizPlanOrderSuspense<TData = Awaited<ReturnType<typeof getQuizPlanOrder>>, TError = ErrorType<unknown>>(
 params: GetQuizPlanOrderParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuizPlanOrder>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetQuizPlanOrderSuspense<TData = Awaited<ReturnType<typeof getQuizPlanOrder>>, TError = ErrorType<unknown>>(
 params: GetQuizPlanOrderParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuizPlanOrder>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetQuizPlanOrderSuspense<TData = Awaited<ReturnType<typeof getQuizPlanOrder>>, TError = ErrorType<unknown>>(
 params: GetQuizPlanOrderParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuizPlanOrder>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 퀴즈 플랜 주문 조회
 */

export function useGetQuizPlanOrderSuspense<TData = Awaited<ReturnType<typeof getQuizPlanOrder>>, TError = ErrorType<unknown>>(
 params: GetQuizPlanOrderParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuizPlanOrder>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetQuizPlanOrderSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 사용자의 결제 가능 여부 및 사용 가능한 플랜 목록을 조회합니다.
 * @summary 사용자 플랜 사용 가능 여부 조회
 */
export const getUserPlanAvailability = (
    
 options?: SecondParameter<typeof httpsInstance>,signal?: AbortSignal
) => {
      
      
      return httpsInstance<SuccessBodyGetUserPlanAvailabilityResponse>(
      {url: `/quiz-plans/availability`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserPlanAvailabilityQueryKey = () => {
    return [`/quiz-plans/availability`] as const;
    }

    
export const getGetUserPlanAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof getUserPlanAvailability>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPlanAvailability>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserPlanAvailabilityQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserPlanAvailability>>> = ({ signal }) => getUserPlanAvailability(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserPlanAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserPlanAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getUserPlanAvailability>>>
export type GetUserPlanAvailabilityQueryError = ErrorType<unknown>


export function useGetUserPlanAvailability<TData = Awaited<ReturnType<typeof getUserPlanAvailability>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPlanAvailability>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPlanAvailability>>,
          TError,
          Awaited<ReturnType<typeof getUserPlanAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserPlanAvailability<TData = Awaited<ReturnType<typeof getUserPlanAvailability>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPlanAvailability>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPlanAvailability>>,
          TError,
          Awaited<ReturnType<typeof getUserPlanAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserPlanAvailability<TData = Awaited<ReturnType<typeof getUserPlanAvailability>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPlanAvailability>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 사용자 플랜 사용 가능 여부 조회
 */

export function useGetUserPlanAvailability<TData = Awaited<ReturnType<typeof getUserPlanAvailability>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPlanAvailability>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserPlanAvailabilityQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetUserPlanAvailabilitySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUserPlanAvailability>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserPlanAvailability>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserPlanAvailabilityQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserPlanAvailability>>> = ({ signal }) => getUserPlanAvailability(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserPlanAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserPlanAvailabilitySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUserPlanAvailability>>>
export type GetUserPlanAvailabilitySuspenseQueryError = ErrorType<unknown>


export function useGetUserPlanAvailabilitySuspense<TData = Awaited<ReturnType<typeof getUserPlanAvailability>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserPlanAvailability>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserPlanAvailabilitySuspense<TData = Awaited<ReturnType<typeof getUserPlanAvailability>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserPlanAvailability>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserPlanAvailabilitySuspense<TData = Awaited<ReturnType<typeof getUserPlanAvailability>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserPlanAvailability>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary 사용자 플랜 사용 가능 여부 조회
 */

export function useGetUserPlanAvailabilitySuspense<TData = Awaited<ReturnType<typeof getUserPlanAvailability>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserPlanAvailability>>, TError, TData>>, request?: SecondParameter<typeof httpsInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserPlanAvailabilitySuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



